function readCvs(fileBlob) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.readAsText(fileBlob);
    reader.onload = function () {
      resolve(reader.result);
    };
  });
}

function toCsv(json) {

  var objs = typeof json === "string" ? JSON.parse(json) : json;

  if (!Array.isArray(objs)) {
    throw new Error("the json must be from an object array!");
  }

  var head = Object.keys(objs[0]);
  var result = objs.map(function (obj) {
    return head
      .map(function (key) {
        return obj[key];
      })
      .join(",");
  });

  result.unshift(head.join(","));

  return result.join("\n");
}

function toJson(csv, asString=false) {
  if (typeof csv !== "string") {
    throw new Error("the csv must be string!");
  }

  var arr = csv
    .split("\n").filter((s) => s)
    .map(function (raw) {
      return raw.split(",");//.filter((s) => s);
    })
    .filter((row) => row.length > 0);
  var head = arr[0];

  var data = arr.slice(1).map(function (raw) {
    return raw.reduce(function (out, value, index) {
      out[head[index]] = value;
      return out;
    }, {});
  });

  if (asString) {
    return JSON.stringify(data, null, 2);
  } else {
    return data
  }
}


export const CsvUtils = {
    readCvs,
    toCsv,
    toJson,
}
